<template lang="pug">
    .popup-container(v-if="isHidden")
        .popup-wrapper
            a(href="" @click.prevent="toggle").popup-close
                img(src="@/assets/images/misc/popup-close.svg")

            carousel(:items=1 :margin=10 :dots="false" :nav="false" :navSpeed="1000" v-closable="{ exclude: [], handler: 'onClose' }" ).rooms-slider                             
                template(slot="prev")
                    .prev
                        img(src="@/assets/images/misc/prev-arrow.svg")

                template(slot="next")
                    .next
                        img(src="@/assets/images/misc/next-arrow.svg")

                .item(v-for="image in selectedResource.image")
                    .slider-thumb(:style="{ backgroundImage: `url(${image.path})` }")
                    h3 {{ selectedResource.hall_name }}
                    div(v-html="selectedResource.description")                    

</template>

<script>
    import carousel from 'vue-owl-carousel'

    export default {
        name: 'ResourceSlider',
        data() {
            return {
                slider: {
                    image: 'https://picsum.photos/id/502/700/460',
                    image2: 'https://picsum.photos/id/503/700/460',
                    image3: 'https://picsum.photos/id/504/700/460',
                },
                isHidden: false
            }
        },
        components: {
            carousel
        },
        props: ['selectedResource'],
        methods: {            
            toggle: function() {
                this.isHidden = !this.isHidden
            },
            onClose: function() {
                this.isHidden = false;
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_popup-slider.sass"    
</style>